<template>
    <app-layout class="index">
        <router-view></router-view>
        <dialog-highly-permission kind="下载"></dialog-highly-permission>
    </app-layout>
</template>

<script>
import DialogHighlyPermission from '@/components/dialog/dialog-highly-permission';
import AppLayout from '@/components/layout/app-layout';
export default {
    name: 'Download',
    components: { DialogHighlyPermission, AppLayout }
};
</script>
